/**
 * 최근 본 항목 기록 (v2.319.0 · Salesforce Recently Viewed) — 상세 창이 열리면 한 번 서버에 적는다(그리지 않는다).
 *   쓰는 곳: 영업건 상세(SalesDetailModal) · 거래처 360(PartnerDetailModal). 헤더 🕘 와 검색창 포커스 목록이 읽는다.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { recordRecent, type RecentKind } from '../lib/nav-api';

export function RecentRecorder({ kind, refId, label, path }: { kind: RecentKind; refId: string; label: string; path: string }) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!refId || !label) return;
    recordRecent({ kind, refId, label, path });
    const t = setTimeout(() => { void qc.invalidateQueries({ queryKey: ['nav', 'recent'] }); }, 800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, refId]);
  return null;
}
